import React, { useState } from 'react';
import { Row, Container } from 'react-bootstrap';
import LocRatingMap from '@Components/map/loc-rating-map';
import { MapMarkerInfoBox } from '@Components/map/map-marker';
/**
 * Components
 */

const OfficeLandingMap = (props) => {


    const [] = useState('')
    // Get Map Details
    let mapItems = [];
    {
            let mapItem = {};
            mapItem['lat'] = props.Latitude
            mapItem['lng'] = props.Longitude
            const mapMarkerImageShowFlag = 1;
            let mapItemHtml = MapMarkerInfoBox(props.Name);
            // console.log(mapItemHtml);
            mapItem['html'] = mapItemHtml;
            mapItems.push(mapItem);
    };
    return (
        <div className="static-wave property-map office-landing-map" id="property-map">
            <div className="wave__video">
                <LocRatingMap zoom="11" data={mapItems} />
            </div>
        </div>
    )
}

export default OfficeLandingMap
